export const PLACEHOLDER_INTERACTION_ID_USER_MESSAGE = 'PLACEHOLDER_INTERACTION_ID_USER_MESSAGE';